import { Theme, useMediaQuery } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { DesktopWrapper } from "./DesktopWrapper.js";
import { ChatList } from "./ChatList.tsx";
import ChatWindow from "./ChatWindow.tsx";
import { useParams } from "react-router-dom";
import { Helper } from "../../tools/Helper.js";
import { api_Routes } from "../../api_Routes.js";

export const ChatInterface = ({}) => {
  const [messages, setMessages] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const messagesContainerRef = useRef<HTMLUListElement>(null);
  const [selectedConversation, setSelectedConversation] = useState<
    number | null
  >(null);
  const id = useParams();
  const [conversations, setConversations] = useState<any[]>([]);
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );
  const userString = localStorage.getItem("user");
  let currentUser = { id: 1, name: "" };
  if (userString) {
    const user = JSON.parse(userString);
    currentUser = { id: user.user_id, name: user.name };
  }
  useEffect(() => {
    const fetchConversations = async () => {
      try {
        const { response, messages } = await Helper.Get({
          url: api_Routes.UserChat.View,
          hasToken: true,
        });
        if (response) setConversations(response.data);
      } catch (error) {
        console.error("Error fetching conversations:", error);
      }
    };

    fetchConversations();
  }, []);
  const maintainScrollPosition = () => {
    const container = messagesContainerRef.current;
    if (!container) return;

    const prevScrollHeight = container.scrollHeight;
    requestAnimationFrame(() => {
      if (container) {
        container.scrollTop = container.scrollHeight - prevScrollHeight;
      }
    });
  };
  const fetchMessages = async () => {
    setIsLoadingMore(true);
    try {
      let url = api_Routes.UserChat.Start;
      if (id.id) {
        url += `?user_id=${id.id}`;
      } else {
        url += `?conversation_id=${selectedConversation}`;
      }
      const nextPage = currentPage + 1;
      url += `&page=${nextPage}`;
      const { response, message } = await Helper.Get({
        url,
        hasToken: true,
      });
      if (response?.data?.messages?.length) {
        setCurrentPage(nextPage);
        setMessages((prev) => [...response.data.messages, ...prev]);
        maintainScrollPosition();
      } else {
        setHasMore(false);
      }
      if (response?.data?.conversation_id) {
        setSelectedConversation(response.data.conversation_id);
      }
      setIsLoadingMore(false);
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };
  // Fetch messages
  useEffect(() => {
    if (selectedConversation || id.id) {
      fetchMessages();
    }
  }, [selectedConversation]);

  return (
    <DesktopWrapper>
      {!isMobile && (
        <ChatList
          conversations={conversations}
          setSelectedConversation={setSelectedConversation}
        />
      )}

      {isMobile ? (
        selectedConversation || id.id ? (
          <ChatWindow
            setSelectedConversation={setSelectedConversation}
            selectedConversation={
              selectedConversation ? selectedConversation : Number(id.id)
            }
            messages={messages}
            currentUser={currentUser}
            loadMoreMessages={fetchMessages}
            isLoadingMore={isLoadingMore}
            hasMore={hasMore}
            messagesContainerRef={messagesContainerRef}
            maintainScrollPosition={maintainScrollPosition}
            setMessages={setMessages}
          />
        ) : (
          <ChatList
            conversations={conversations}
            setSelectedConversation={setSelectedConversation}
          />
        )
      ) : (
        <ChatWindow
          setSelectedConversation={setSelectedConversation}
          selectedConversation={selectedConversation}
          messages={messages}
          currentUser={currentUser}
          loadMoreMessages={fetchMessages}
          isLoadingMore={isLoadingMore}
          hasMore={hasMore}
          messagesContainerRef={messagesContainerRef}
          maintainScrollPosition={maintainScrollPosition}
          setMessages={setMessages}
        />
      )}
    </DesktopWrapper>
  );
};
